import { ApiShapeError, currencyGet } from '@/lib/task-api';
import type { RateBulletin, RateBulletinItem } from '@/lib/rate-mapping';

/**
 * TCMB BULTENI — SUNUCU VEKILI UZERINDEN.
 *
 * Tarayici TCMB'ye DOGRUDAN gidemez: today.xml'de CORS basligi yok, istek
 * tarayici tarafindan engellenir. (Mobil istemci gidebiliyor; React Native'de
 * CORS diye bir sey yok. Bu, iki istemcinin ayrildigi noktalardan biri.)
 *
 * Vekil ayrica 60 saniye onbellekliyor ve TCMB'ye ulasamadiginda SON BILINEN
 * bulteni `stale: true` ile donuyor.
 */

type RatesResponse = {
  code?: string;
  message?: string;
  bulletinNo?: string | null;
  bulletinDate?: string | null;
  fetchedAt?: string | null;
  stale?: boolean;
  items?: unknown;
};

export const getRates = async (): Promise<RateBulletin> => {
  const { data } = await currencyGet<RatesResponse>('/v1/rates');
  // Sessizce bos bir kur listesine DUSULMEZ: bos bir tablo, kullaniciya
  // "bugun kur yok" der ve bu hicbir zaman dogru degildir.
  if (!Array.isArray(data.items)) throw new ApiShapeError('/v1/rates.items dizi degil');
  return {
    bulletinNo: data.bulletinNo ?? null,
    bulletinDate: data.bulletinDate ?? null,
    fetchedAt: data.fetchedAt ?? null,
    // Alan gelmediyse "taze" varsayilir; bayatligi UYDURMAK, gercek bir bayat
    // bulteni gizlemekten farkli bir hata degil ama daha az yaniltici.
    // `stale` YALNIZ TCMB'ye ulasilamadiginda true olur. Bultenin tarihinin
    // eski olmasi (hafta sonu, resmi tatil -> son is gunu bulteni) NORMALDIR ve
    // bayatlikla karistirilmaz; ikisi ekranda da ayri gosterilir.
    stale: data.stale === true,
    items: data.items as RateBulletinItem[],
  };
};
